// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1SolY","unreadBadge":"styles_unreadBadge__xlVZj","modalContent":"styles_modalContent__27_T4","modal":"styles_modal__e0A1L"};